export const matchMakingBasicPersonalInfoFields = [
    { label: 'First Name', key: 'requestorFirstName' },
    { label: 'Last Name', key: 'requestorLastName' },
    { label: 'Job Title', key: 'requestorJobTitle' },
    { label: 'Mobile Number', key: 'requestorMobileNumber' },
    { label: 'Work Email', key: 'requestorWorkEmail' },
    {
        label: 'How did your company hear about the Business in Dubai Program of the Dubai Chamber of Digital Economy?',
        key: 'whereYourCompanyHearAboutBIDProgram'
    },
    {
        label: 'Please specify how you heard about the Business in Dubai Program.',
        key: 'otherValueForBIDProgramReference'
    }
];
export const matchMakingBasicBusinessInforFields = [
    {
        label: 'Do you have register company in UAE?',
        key: 'uaeOfficeReference'
    },
    {
        label: 'In which Emirate company is registered?',
        key: 'registeredCompanyEmiratesReference'
    },
    {
        label: 'Are you a Dubai Chamber member?',
        key: 'dubaiChamberMemberReference'
    },
    { label: 'Dubai Chamber Membership number', key: 'membershipNumber' },
    { label: 'Trade License Number', key: 'tradeLicenseNumber' },
    { label: 'Your Business Name', key: 'requestorBusinessName' },
    {
        label: 'Is the business owned or co-founded by a UAE national?',
        key: 'businessOwnedOrCofoundedByUAE'
    },
    { label: 'Country of Origin', key: 'requestorCountryOrOrigin' },
    { label: 'City', key: 'requestorCity' },
    {
        label: 'Year of Business Incorporation',
        key: 'requestorBusinessIncorporationYear'
    },
    { label: 'Comapany Website URL', key: 'requestorCompanyWebsiteURL' }
];

export const matchMakingBusinessProfileInfoField = [
    { label: 'Type of Business Model', key: 'requestorBusinessModelType' },
    {
        label: 'Please specify other Business Model',
        key: 'otherTypeOfBusinessModel'
    },
    { label: 'Annual Revenue (in USD)', key: 'requestorAnnualRevenue' },
    {
        label: 'Current business valuation (in USD) ',
        key: 'requestorCurrentBusinessValuation'
    },
    { label: 'Number of Employees Globally', key: 'numberOfEmployees' },
    {
        label: 'Please Select the industry sector that best represents your tech business',
        key: 'requestorTechBusinessIndustrySector'
    },
    { label: 'Your Vertical Industry', key: 'requestorIndustryVertical' },
    {
        label: 'Please specify other industry vertical',
        key: 'otherIndustryVertical'
    },
    {
        label: 'Please provide information about the current funding stage of your company',
        key: 'requestorCompanyCurrentFundingStage'
    },
    {
        label: 'Please specify the alternative funding source',
        key: 'otherCompanyCurrentFundingStage'
    },
    {
        label: 'Please select the countries outside your country headquarters where you have offices in',
        key: 'requestorOutsideHeadquarterCountires'
    },
    {
        label: 'Please select the size of the past collaboration and clients you have worked with',
        key: 'requestorPastCollaborationAndClientSize'
    },
    { label: 'Attached MOA', key: 'attachedMOA' },
    {
        label: 'List key clients you have worked with in the past that you are hoping to find the equivalent of in Dubai (Please specify brands or company names)',
        key: 'requestorClientsListKey'
    }
];
export const matchMakingDubaiMarketInfoFields = [
    {
        label: 'Do you sell your products or services in Dubai or UAE today?',
        key: 'requestorAnswerForTodaysSellInDubaiOrUAE'
    },
    {
        label: 'Please specify your current sales or business presence status in Dubai or the UAE',
        key: 'otherAnswerForTodaySell'
    },
    {
        label: 'Are there specific entities in Dubai that you would ideally like to be introduced to? (Provide the name of the specific organization and/or company)',
        key: 'introduceRequestorSpecificEntitiesInDubai'
    },
    {
        label: 'Have you reached out to them in the past?',
        key: 'requestorReachedOutThemInPast'
    },
    {
        label: 'Please provide more details about your outreach',
        key: 'otherSpecificationForReachedOut'
    },
    {
        label: 'How ready are you to open a company in Dubai?',
        key: 'howRequestorAreReadyToOpenCompany'
    },
    {
        label: 'Please specify your current plans regarding opening a company in Dubai',
        key: 'otherAnswerForDubaiStartup'
    },
    {
        label: 'Please select the technology readiness level of your products',
        key: 'productTechnologyReadiness'
    },
    {
        label: 'What business categories do you want to be connected with in Dubai?',
        key: 'requestorWantedCategoriesToBeConnected'
    },
    {
        label: 'Please specify the business categories you would like to connect with in Dubai',
        key: 'otherCategoriesWantedToConnectInDubai'
    },
    {
        label: 'What are your biggest challenges in doing business in the UAE?',
        key: 'requestorBiggestChallangesInUAEStratup'
    },
    {
        label: 'Please specify the challenges your business is facing in the UAE',
        key: 'otherAnswerForChallanges'
    },
    {
        label: 'Please share a One-Line Summary explaining your business (Write 10 to 15 words, allowing for a concise and impactful summary)',
        key: 'requestorBusinessExplanation'
    }
];
export function getDetailsValue(value: any, fallback: string = '-'): string {
    if (
        value === null ||
        value === undefined ||
        value === 'null' ||
        value === 'null null' ||
        (typeof value === 'string' && value.trim() === '')
    ) {
        return fallback;
    }
    return String(value);
}
export type FileData = {
    objectEntryId?: number; // Use AttendeeId instead of id
    documentName: string;
    href: string;
    fileBase64?: string;
};
export type Column<T> = {
    header: string;
    accessor: keyof T;
    type:
        | 'text'
        | 'select'
        | 'searchSelect'
        | 'id'
        | 'number'
        | 'date'
        | 'boolean'
        | 'selectMultiple'
        | 'searchSelectMultiple'
        | 'time';
    options?: string[];
    width?: string;
    visible?: boolean;
};

export const UploadedFileDataColumns: Column<FileData>[] = [
    {
        header: 'Id',
        accessor: 'objectEntryId',
        type: 'id',
        width: '15%',
        visible: false
    },
    { header: 'Document Name', accessor: 'documentName', type: 'text' }
];
export interface UserDetails {
    name: string;
    department?: string;
    image: string;
    mobileNumber: string;
    emailAddress: string;
    roleBriefs: {
        id: number;
        name: string;
    }[];
    [key: string]: any;
}

export type Telephone = {
    extension: string;
    phoneNumber: string;
    primary: boolean;
};

export type UserAccountContactInformation = {
    postalAddresses: PostalAddress[];
    telephones: Telephone[];
};

export type Briefs = {
    id: number;
    name: string;
};
export type CustomField = {
    customValue: {
        data: string | boolean;
    };
    dataType: string;
    name: string;
};
export type PostalAddress = {
    addressCountry: string;
    primary: boolean;
};
export type UserAccount = {
    id: number;
    customFields: CustomField[];
    emailAddress: string;
    externalReferenceCode: string;
    image: string;
    name: string;
    userAccountContactInformation: UserAccountContactInformation;
    jobTitle: string;
    roleBriefs: Briefs[];
    userGroupBriefs: Briefs[];
    items: {};
};
export interface PartnerSlot {
    id: string;
    dateTime: string;
}
export interface PartnerSelectionRow {
    id: string;
    companyId: string;
    slots: PartnerSlot[];
    companyName?: string;
    industry?: string;
    email?: string;
    status?: string;
}
export const matchMakingPartnerDetails = [
    { label: 'Company Name', key: 'companyName' },
    {
        label: 'Email',
        key: 'email'
    },
    { label: 'Industry', key: 'industry' },
    {
        label: 'First Slot ',
        key: 'firstSlot'
    },
    { label: 'Second Slot', key: 'secondSlot' },
    { label: 'Third Slot', key: 'thirdSlot' },
    {
        label: 'Partner Selected Slot',
        key: 'partnerSelectedSlot'
    },
    {
        label: 'Status',
        key: 'partnerResponse'
    }
];
